import { Box, Stack, useTheme } from '@mui/material';
import Paper from '@/components/Paper';
import useResponsive from '@/hooks/useResponsive';
import Typography from '@/components/Typography';
import SeeMore from '@/components/CustomSeeMore';
import { useRouter } from 'next/router';
import Badge from '../../Badge';
import ContractBadgeComponent from '../../Badge/ContractBadge';
import HeaderBadgeComponent from '../../Badge/HeaderBadge';
import { contractsT, socialMediaT, usefulLinksT, walletsT } from '../types';
import { FC } from 'react';
import getLocalFile from '@/utils/getLocalFile';

const CryptoContentComponent: FC<{ isPricePage?: boolean }> = ({
  isPricePage
}) => {
  const { matches } = useResponsive();
  const theme = useTheme();

  const {
    query: { symbol }
  } = useRouter();
  const marketName = symbol?.toString().toUpperCase() || '';
  const data = getLocalFile(marketName, 'info');
  const content = getLocalFile(marketName, 'content');

  return (
    <Stack
      mb={{ xs: 4, lg: 10 }}
      // mt={{ xs: 1.5, lg: 11 }}
      flexDirection={{ lg: 'row', md: 'column' }}
      gap={4}
    >
      <Stack
        sx={{
          width: matches({
            lg: isPricePage ? '100%' : '772.86076px',
            xs: '100vw'
          })
        }}
      >
        <Paper
          elevation={0}
          sx={{ p: matches({ xs: 4, lg: 8 }), pt: 0, flex: 1 }}
        >
          <Box>
            <Box sx={{ height: '100%' }}>
              <Stack
                sx={{
                  '& img': {
                    display: 'block',
                    margin: 'auto'
                  },
                  '& p': {
                    color: theme.palette.textColor.A60,
                    fontSize: matches({ xs: '12px', lg: '14px' }),
                    pb: 3,
                    textAlign: 'start'
                  },
                  '& h4': {
                    fontSize: matches({ xs: '14px', lg: '16px' }),
                    color: theme.palette.textColor.A80,
                    pb: 2,
                    fontWeight: 600
                  },
                  '& h3': {
                    fontSize: matches({ xs: '14px', lg: '16px' }),
                    color: theme.palette.textColor.A80,
                    pb: 2,
                    fontWeight: 600
                  },
                  '& h2': {
                    fontSize: matches({ xs: '14px', lg: '16px' }),
                    color: theme.palette.textColor.A80,
                    pb: 2,
                    fontWeight: 600
                  },
                  '& h1': {
                    fontSize: matches({ xs: '14px', lg: '16px' }),
                    color: theme.palette.textColor.A80,
                    pb: 2,
                    fontWeight: 600
                  },
                  '& a': {
                    textDecoration: 'none',
                    color: theme.palette.primary.main
                  },
                  '& ol': {
                    color: theme.palette.textColor.A60,
                    fontSize: '14px',
                    textAlign: 'justify',
                    pl: matches({ xs: 4, lg: 14 }),
                    py: 5.5
                  }
                }}
                gap={4}
              >
                <SeeMore
                  height="20%"
                  minHeight="200px"
                  linearGradient="rgba(255, 255, 255, 0.00)"
                  buttonProps={{
                    variant: 'contained',
                    fullWidth: matches({ xs: false, lg: false })
                  }}
                  fadeColor="#FFF"
                  showMoreText="مشاهده بیشتر"
                  showLessText="مشاهده کمتر"
                >
                  <Box
                    component="div"
                    dangerouslySetInnerHTML={{
                      __html: content?.description || ''
                    }}
                  />
                </SeeMore>
              </Stack>
            </Box>
          </Box>
        </Paper>
      </Stack>
    </Stack>
  );
};

export default CryptoContentComponent;
